import router from './router'
import store from './store'

const whiteList = ['/Login',
'/',
'/EN',
'/CN',
'/JP',
'/password',
'/About',
'/Welcome',
'/Pricing',
'/ContactUs',
'/Signup',
'/LostPassword',
'/Help',
'/Oauth',
'/qwS8caqsi9svzjfS',
'/qwS8caqsi9svzjfS/DownloadProductReport',
'/qwS8caqsi9svzjfS/DownloadSellerPDF',
'/DownloadProductReport',
'/DownloadSellerPDF']

router.beforeEach(async(to, from, next) => {

  const hasToken = localStorage.getItem('token')

  if (hasToken) {
    if (to.path === '/Login') {
      next()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        next()
      } else {
        try {
          next()
        } catch (error) {
          next(`/Login?redirect=${to.path}`)
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if(to.path.indexOf('qwS8caqsi9svzjfS') != -1){
        next()
      } else{
        next(`/Login`)
      }
    }
  }
})

router.afterEach(() => {
  
})
